
export default {
  'oms.common.sku': 'SKU',
  'oms.common.warehouse': 'Warehouse',
  'oms.common.store_name': 'Store Name',
  'oms.common.declared_value': 'Declared Value',
  'oms.common.declared_currency': 'Declared Currency' ,
  'oms.common.message.destination_country': 'Please select destination country',
  'oms.common.loading': 'Loading',
  'oms.common.customer_store_key': 'Customer Store Key',
  'oms.common.customer_sap_code': 'Customer SAP Code',
  'oms.common.batch_request_code': 'Batch Request Code',
  'oms.common.export_to_excel': 'Export your data to excel',
  'oms.common.downloading': 'Downloading',
  'oms.common.download-fail': 'Failed to download, please try again',
  'oms.common.processing': 'Prcoessing',
  'oms.common.cancelling': 'Cancelling',
  'oms.common.generating': 'Generating',
  'oms.common.delete_this_line': 'Delete this line?',
    'oms.common.go_back': 'Go Back',
  'oms.common.status': 'Status',
  'oms.common.amr_pick_status': 'Picking Order Status',
  'oms.common.merchant': 'Merchant',
  'oms.common.platform_code': 'Platform Code',
  'oms.common.external_oms_status': 'External oms Status',
  'oms.common.external_client_status': 'External Client Status',
  'oms.common.container_box': 'Container Box',
  'oms.common.oms_product_sku': 'oms Provider SKU',
  'oms.common.oms_product_bar_code': 'oms Provider Barcode',
  'oms.common.bin': 'Bin',
  'oms.common.bar_code': 'Bar Code',
  'oms.common.product_name': 'Product name',
  'oms.common.ean': 'EAN / UPC',
  'oms.common.good-stock': 'Good',
  'oms.common.like-new-stock': 'Like New',
  'oms.common.bad-stock': 'Damage',
  'oms.common.normal_qty': 'Normal QTY',
  'oms.common.damage_qty': 'Damage QTY',
  'oms.common.quantity': 'QTY',
  'oms.common.put_away.quantity': 'Put Away QTY',
  'oms.common.production_batch_code': 'Production Batch Code',
  'oms.common.production_batch_code_qty': 'Qty of Production Batch Code',
  'oms.common.origin_production_batch_code': 'Origin Production Batch Code',
  'oms.common.expected_qty': 'Expected QTY',
  'oms.common.virtual_warehouse': 'Virtual Warehouse',
  'oms.common.carrier': 'Carrier',
  'oms.common.zone': 'Zone',
  'oms.common.warehouse.bin': 'Bin',
  'oms.common.warehouse.bin_zone': 'Bin Zone',
  'oms.common.warehouse.aisle': 'Aisle',
  'oms.common.warehouse.bay': 'Bay',
  'oms.common.warehouse.level': 'Level',
  'oms.common.warehouse.position': 'Position',
  'oms.common.inventory_status': 'Inventory Status',
  'oms.common.waybill': 'Waybill',
  'oms.common.invoice': 'Invoice',
  'oms.common.processing.message': 'Processing ...',
  'oms.common.updating.message': 'Updating ...',
  'oms.common.removing.message': 'Removing ...',
  'oms.common.removing.fail.message': 'Fail to remove',
  'oms.common.message.download.successfully': 'Download Successfully',
  'oms.common.operate_warehouse': 'Current Warehouse',
  'oms.common.select_operate_warehouse': 'Select a Warehouse',
  'oms.common.select_company_first': 'You will need to select a merchant first',
  'oms.common.no_relevant_data': 'No relevant data',
  'oms.common.ftp-folder': 'FTP Folder',
  'oms.common.serial-scanned-before':
    'The serial number {serial_num} has been scanned before, please check it',
  'oms.common.any-scanned-before': 'The {codenum} has been scanned, please check it',
  'oms.common.pick_multi_item': 'Multi Items',
  'oms.common.pick_simple_item': 'One Item',
  'oms.common.confirm-yes': 'Yes, confirm',
  'oms.common.receiving_uuid': 'Receiving ID',
  'oms.common.serial-scanned-max-qty': 'Require Scan {length} Serial Numbers',
  'oms.common.require_scan_serial_number_length': 'Require Scan {length} Serial Numbers',
  'oms.common.sorting_expiry_date_tooltips': 'Are you sure to want to receive the expired product?',
  'oms.common.warning.duplicate-serial-number':
    'The serial number {serialNum} has already exist in oms, please check it',
  'oms.common.warning.sku-require-scan-serial-number': `The SKU - {scannedEanOrUpcCode} requires S/N scanning during pack`,
  'oms.common.warning.serial-number-already-scanned':
    'The serial number {ssn} already scanned before',
  'oms.common.column-search-value-placeholder': 'Search value',
  'oms.common.printing': 'Printing ...',
};
